<template>
	<v-card elevation="0">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col>
					<v-toolbar-title>{{ $t('edit') }} {{ $t('consumable-catalog') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense v-if="editingCatalog">
				<v-col cols="12">
					<v-select
						dense
						v-model="editingCatalog.category"
						:items="inventoryConsumableCategoryOptions"
						:label="$t('category')"
						hide-details
						outlined
						item-value="code"
						item-text="code" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('name')" v-model="editingCatalog.name" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('manufacturer')" v-model="editingCatalog.manufacturer" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('internal-product-code')"
						v-model="editingCatalog.internalProductCode" />
				</v-col>
				<v-col cols="12">
					<v-select
						dense
						v-model="editingCatalog.unitOfMeasure"
						:items="inventoryConsumableUnitOfMeasureOptions"
						:label="$t('unit-of-measure')"
						hide-details
						outlined
						item-value="code"
						item-text="code" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('min-stock-threshold')"
						v-model="editingCatalog.minStockThreshold"
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()" />
				</v-col>
				<v-col cols="12">
					<v-textarea rows="5" dense hide-details outlined :label="$t('notes')" v-model="editingCatalog.notes" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="!isSaveButtonDisabled" @click="editConsumable">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'EditInventoryConsumableCatalog',
	data () {
		return {
			inventoryItems: [],
			loading: false,
			itemModel: {
				name: '',
				manufacturer: '',
				internalProductCode: '',
				unitOfMeasure: '',
				minStockThreshold: 0,
				notes: '',
				category: '',
			},
			editingCatalog: {
				name: '',
				manufacturer: '',
				internalProductCode: '',
				unitOfMeasure: '',
				minStockThreshold: 0,
				notes: '',
				category: '',
			},
			inventoryConsumableCategoryOptions: [],
			inventoryConsumableUnitOfMeasureOptions: [],
		};
	},
	methods: {
		...mapActions({
			getInventoryConsumableCategoryOptions: 'inventoryConsumableCatalogs/getInventoryConsumableCategoryOptions',
			getInventoryUnitOfMeasureOptions: 'inventoryConsumableCatalogs/getInventoryUnitOfMeasureOptions',
			addConsumableCatalog: 'inventoryConsumableCatalogs/addConsumableCatalog',
			editConsumableCatalog: 'inventoryConsumableCatalogs/editConsumableCatalog',
		}),
		closeDrawer () {
			this.editingCatalog = this.itemModel;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
		},
		async editConsumable () {
			const resultEdit = await this.editConsumableCatalog(this.editingCatalog);
			if (resultEdit) {
				this.closeDrawer();
			}
		},

		async getCategoriesAndUnitOfMeasure () {
			this.inventoryConsumableCategoryOptions = await this.getInventoryConsumableCategoryOptions();

			const resultUnitOfMeasure = await this.getInventoryUnitOfMeasureOptions();
			this.inventoryConsumableUnitOfMeasureOptions = resultUnitOfMeasure;
		},
	},
	computed: {
		...mapState({
			selectedConsumableCatalog: (state) => state.inventoryConsumableCatalogs.selectedConsumableCatalog,
		}),
		isSaveButtonDisabled () {
			return (
				this.editingCatalog.category?.length > 0 &&
				this.editingCatalog.name.trim() !== '' &&
				this.editingCatalog.manufacturer.trim() !== '' &&
				this.editingCatalog.internalProductCode.trim() !== '' &&
				this.editingCatalog.unitOfMeasure.trim() !== '' &&
				this.editingCatalog.minStockThreshold !== '' &&
				Number(this.editingCatalog.minStockThreshold) >= 0
			);
		},
	},
	async mounted () {
		this.editingCatalog = this.selectedConsumableCatalog;
		await this.getCategoriesAndUnitOfMeasure();
	},
	watch: {
		async selectedConsumableCatalog (newVal) {
			this.editingCatalog = newVal;
			await this.getCategoriesAndUnitOfMeasure();
		},
	},
};
</script>
